import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "@/assets/css/styles.css";
import "@/assets/css/common.css";
import Toast from "vue-toastification";
import VueConfirmDialog from "vue-confirm-dialog";
import "vue-toastification/dist/index.css";
import Global from "./global";
import { GridGlobal } from "gridjs-vue";
import Raphael from "raphael/raphael";
import chartjsPluginAnnotation from "chartjs-plugin-annotation";
global.Raphael = Raphael;
window.$global = new Global(Vue, store);

const options = {
  position: "bottom-center",
  timeout: 3000,
};

Vue.use(GridGlobal);
Vue.use(Toast, options);
Vue.use(VueConfirmDialog);
Vue.use(chartjsPluginAnnotation);
Vue.component("vue-confirm-dialog", VueConfirmDialog.default);
Vue.config.productionTip = false;
Vue.prototype.$env = process.env.NODE_ENV;

window.$global.build().then(() => {
  new Vue({
    router,
    store,
    render: (h) => h(App),
  }).$mount("#app");
  console.log(`process.env => ${process.env.NODE_ENV}`);
});
